// extracted by mini-css-extract-plugin
export default {"note":"note__dCAnV","iconContainer":"iconContainer__rpeFU","icon":"icon__czI21"};